document.addEventListener('DOMContentLoaded', () => {
    // Prüfen, ob die Seite die entsprechende Body-Klasse hat
    if (!document.body.classList.contains('page-template-page-results')) {
      return;
    }

    // Overlay-Klick: Schaltet Play/Pause um. Bei manuellem Start wird das Video unmuted.
    const overlays = document.querySelectorAll('.results--video--block .video--overlay');
    overlays.forEach(overlay => {
      overlay.addEventListener('click', function(e) {
        e.stopPropagation();
        const video = this.querySelector('.initVideo');
        const cardInner = this.closest('.browser--card--inner');
        if (!video) return;

        if (video.paused) {
          // Bei manuellem Start wird unmuted, damit man den Ton hört
          delete video.dataset.userPaused;
          video.muted = false;
          video.play().then(() => {
            $(this).addClass('disabled');
            if (cardInner) {
              const muteToggle = $(cardInner).find('.mute-toggle');
              muteToggle.removeClass('hidden');
              // Bei unmuted Zustand soll das Volume-Icon angezeigt werden
              muteToggle.find('.icon-volume').removeClass('hidden');
              muteToggle.find('.icon-mute').addClass('hidden');
            }
          }).catch(error => {
            console.warn('Play failed:', error);
          });
        } else {
          video.pause();
          video.dataset.userPaused = 'true';
          $(this).removeClass('disabled');
          if (cardInner) $(cardInner).find('.mute-toggle').addClass('hidden');
        }
      });
    });

    // Direkte Bindung für die Mute/Unmute-Buttons
    const muteToggles = document.querySelectorAll('.results--video--block .mute-toggle');
    muteToggles.forEach(muteToggle => {
      muteToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        const cardInner = this.closest('.browser--card--inner');
        const video = cardInner.querySelector('.initVideo');
        if (!video) return;

        video.muted = !video.muted;
        const volumeIcon = this.querySelector('.icon-volume');
        const muteIcon = this.querySelector('.icon-mute');
        if (video.muted) {
          if (volumeIcon) volumeIcon.classList.add('hidden');
          if (muteIcon) muteIcon.classList.remove('hidden');
        } else {
          if (volumeIcon) volumeIcon.classList.remove('hidden');
          if (muteIcon) muteIcon.classList.add('hidden');
        }
      });
    });
  });
